import { useEffect, useState } from 'react';

import { Icon, IconButton, Progress } from '@atom/mui';
import { ArrowDropDownIcon, ArrowRightIcon, FolderIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { PolicyAction } from '@atom/types/policy';
import { WorkTemplateFolderTree } from '@atom/types/workTemplate';
import api from '@atom/utilities/api';
import { WORK_TEMPLATES_FOLDER_TREE_ENDPOINT } from '@atom/utilities/endpoints';

import WorkTypeFolderTreeRow from './WorkTypeFolderTreeRow';

import classes from './workTypeFolderTree.module.css';

const styles = {
  arrowStyle: {
    fontSize: '24px',
    margin: 0,
    color: colors.neutral.dim,
  },
  indentation: {
    paddingLeft: '2rem',
  },
  iconStyle: {
    fontSize: '24px',
    margin: 0,
    color: colors.neutral.gray,
  },
};

interface Props {
  setWorkTemplateFolder: any;
  setActiveView: () => void;
}

const WorkTypeFolderTree = ({
  setWorkTemplateFolder,
  setActiveView,
}: Props) => {
  const [open, setOpen] = useState<Set<string>>(new Set(['workTypes']));
  const [loadingTree, setLoadingTree] = useState<boolean>(true);
  const [workTemplateFolderTree, setWorkTemplateFolderTree] =
    // @ts-ignore
    useState<WorkTemplateFolderTree>({});

  useEffect(() => {
    const getWorkTemplateFolderTree = async () => {
      setLoadingTree(true);

      const { data } = await api.get(
        `${WORK_TEMPLATES_FOLDER_TREE_ENDPOINT}?action=${PolicyAction.READ}`,
      );

      setWorkTemplateFolderTree(data);
      setLoadingTree(false);
    };

    getWorkTemplateFolderTree();
  }, []);

  const toggleOpen = (id: string) => {
    if (open.has(id)) {
      open.delete(id);
      setOpen(new Set([...open]));
    } else {
      setOpen(new Set([...open.add(id)]));
    }
  };

  const selectWorkTemplateFolder = (folder: WorkTemplateFolderTree) => {
    setWorkTemplateFolder(folder);
    setActiveView();
  };

  const expanded = open.has(workTemplateFolderTree.id);
  const arrowDirection = expanded ? ArrowDropDownIcon : ArrowRightIcon;

  return (
    <div className={classes.treeModalContainer}>
      {loadingTree ? (
        <Progress />
      ) : (
        <>
          <div
            className={classes.folderRow}
            onClick={() => toggleOpen(workTemplateFolderTree.id)}
          >
            <div className={classes.folderNameContainer}>
              <IconButton>
                <Icon style={styles.arrowStyle} icon={arrowDirection} />
              </IconButton>
              <Icon style={styles.iconStyle} icon={FolderIcon} />
              <div className={classes.rowNameContainer}>
                <div className={classes.rowTitle}>
                  {workTemplateFolderTree.name}
                </div>
              </div>
            </div>
          </div>
          {expanded ? (
            <>
              {workTemplateFolderTree.children.map(
                (child: WorkTemplateFolderTree) => (
                  <WorkTypeFolderTreeRow
                    key={child.id}
                    folder={child}
                    indentation={0}
                    open={open}
                    toggleOpen={toggleOpen}
                    selectWorkTemplateFolder={selectWorkTemplateFolder}
                  />
                ),
              )}
            </>
          ) : (
            <div />
          )}
        </>
      )}
    </div>
  );
};

export default WorkTypeFolderTree;
